/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Foreignlanguages_Suedliches_Ndebele3Inputs */

const en__field__enum_foreignlanguages_suedliches_ndebele3 = /** @type {(inputs: _Field__Enum_Foreignlanguages_Suedliches_Ndebele3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suedliches_Ndebele`)
};

const de__field__enum_foreignlanguages_suedliches_ndebele3 = /** @type {(inputs: _Field__Enum_Foreignlanguages_Suedliches_Ndebele3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suedliches_Ndebele`)
};

/**
* | output |
* | --- |
* | "Suedliches_Ndebele" |
*
* @param {_Field__Enum_Foreignlanguages_Suedliches_Ndebele3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_foreignlanguages_suedliches_ndebele3 = /** @type {((inputs?: _Field__Enum_Foreignlanguages_Suedliches_Ndebele3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Foreignlanguages_Suedliches_Ndebele3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_foreignlanguages_suedliches_ndebele3(inputs)
	return de__field__enum_foreignlanguages_suedliches_ndebele3(inputs)
});
export { _field__enum_foreignlanguages_suedliches_ndebele3 as "_field__enum_foreignLanguages_Suedliches_Ndebele" }